import { render, staticRenderFns } from "./PSServicesOverview.vue?vue&type=template&id=202b495a&scoped=true"
import script from "./PSServicesOverview.vue?vue&type=script&lang=js"
export * from "./PSServicesOverview.vue?vue&type=script&lang=js"
import style0 from "./PSServicesOverview.vue?vue&type=style&index=0&id=202b495a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b495a",
  null
  
)

export default component.exports